import { PublicClientApplication } from "@azure/msal-browser";

const isDev = process.env.NODE_ENV !== "production";

const CLIENT_ID = process.env.VUE_APP_ENTRA_CLIENT_ID;
const LOGIN_AUTHORITY = process.env.VUE_APP_LOGIN_AUTHORITY;
const RESET_AUTHORITY = process.env.VUE_APP_MSAL_RESET_AUTHORITY;
const redirectUri =
  (isDev
    ? process.env.VUE_APP_REDIRECT_URI_DEV
    : process.env.VUE_APP_REDIRECT_URI) ??
  (typeof window !== "undefined" ? window.location.origin : "/");
const rawKnownAuthorities = process.env.VUE_APP_MSAL_KNOWN_AUTHORITY ?? "";
const knownAuthorities = rawKnownAuthorities
  .split(",")
  .map((value) => value.trim())
  .filter((value) => value.length > 0);

if (!CLIENT_ID) {
  throw new Error(
    "Missing MSAL clientId. Please set VUE_APP_CLIENT_ID or VUE_APP_ENTRA_CLIENT_ID."
  );
}

if (!LOGIN_AUTHORITY) {
  throw new Error(
    "Missing MSAL LOGIN_AUTHORITY. Please set VUE_APP_TENANT_ID or VUE_APP_MSAL_LOGIN_AUTHORITY."
  );
}

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: LOGIN_AUTHORITY,
    redirectUri,
    ...(knownAuthorities.length > 0 ? { knownAuthorities } : {}),
  },
  cache: {
    cacheLocation: "sessionStorage", // invece di localStorage
    storeAuthStateInCookie: false,
  },
};
export const msalConfigReset = {
  auth: {
    clientId: CLIENT_ID,
    authority: RESET_AUTHORITY,
    redirectUri,
    ...(knownAuthorities.length > 0 ? { knownAuthorities } : {}),
  },
  cache: {
    cacheLocation: "sessionStorage", // invece di localStorage
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: [],
};

export const silentTokenRequest = {
  scopes: [],
};

export const resetPasswordRequest = {
  scopes: [],
};

export const msalInstance = new PublicClientApplication(msalConfig);
export const msalInstanceReset = new PublicClientApplication(msalConfigReset);
